export const CANNED_OPEN_CREATE_MODAL = "CANNED_OPEN_CREATE_MODAL";
